import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { ArrowLeftIcon } from '../../../../assets/svg'

const Header = ({ title }) => {
  const navigate = useNavigate()

  return (
    <div className="mb-[1.5rem] lg:mb-[2.5rem] flex items-center gap-[0.75rem] sm:gap-[1rem]">
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="flex h-[2.25rem] w-[2.25rem] sm:h-[2.5rem] sm:w-[2.5rem] shrink-0 items-center justify-center rounded-full border border-solid border-[#e5e7eb] bg-white hover:bg-[#f9fafb]"
      >
        <ArrowLeftIcon />
      </button>
      <h1 className="m-0 text-[1.25rem] sm:text-[1.5rem] lg:text-[2em] font-semibold leading-tight text-[#111827] break-words">
        {title}
      </h1>
    </div>
  )
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
}

export default Header
